import React from "react";
import { FaQuestionCircle } from "react-icons/fa";

interface UpdateJobModalProps {
  isOpen: boolean;
  onConfirm: (applyToPending: boolean) => void;
  onCancel: () => void;
}

const UpdateJobModal: React.FC<UpdateJobModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black bg-opacity-50 transition-opacity"
        onClick={onCancel}
      />

      {/* Modal */}
      <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full mx-4 transform transition-all">
        {/* Header */}
        <div className="flex items-center gap-3 p-6 pb-4">
          <div className="flex-shrink-0">
            <FaQuestionCircle className="text-2xl text-secondary" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900">
              Update Job Details
            </h3>
          </div>
        </div>

        {/* Content */}
        <div className="px-6 pb-4">
          <p className="text-gray-600">
            Do you want all pending interviews for this job to use the updated
            details?
          </p>
        </div>

        {/* Actions */}
        <div className="flex flex-wrap justify-end gap-3 px-6 py-4 bg-gray-50 rounded-b-lg">
         
          <button
            type="button"
            onClick={() => onConfirm(false)}
            style={{
              padding: '8px 16px',
              fontSize: '14px',
              fontWeight: 500,
              color: '#FFFFFF',
              backgroundColor: 'red',
              border: '1px solid red',
              borderRadius: '6px',
              cursor: 'pointer',
              minWidth: '60px',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'red';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'red';
            }}
          >
            No
          </button>
          <button
            type="button"
            onClick={() => onConfirm(true)}
            className="px-4 py-2 text-sm font-medium text-white bg-secondary border border-transparent rounded-md hover:bg-[#1e2a5e] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary transition-colors min-w-[60px]"
          >
            Yes
          </button>
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateJobModal;

